// we need to save the affected form, because the element causing the ajax request may no longer be in DOM (for example when deleting a row)
// so it's not possible to get to the affected form via "closest" anymore
let submitForm;

$.nette.ext("submitForm", {
	before: function (xhr, settings) {

		if (!settings.nette || !$(settings.nette.el[0]).is(':visible')) {
			if (!document.getElementById("palerma-overlay")) {
				var overlay = document.createElement("div");
				overlay.setAttribute("id","palerma-overlay")
				overlay.innerHTML = '<div class="spinner-wrapper"><i class="fa fa-spinner fa-spin"></i></div>';
				document.body.appendChild(overlay);
			}
		} else {
			settings.nette.el.closest('form').find('button').prop('disabled', true);
			settings.nette.el.find('.js-spinner').removeClass('d-none');
			settings.nette.el.closest('form').find('.js-error').remove();
			settings.nette.el.closest('form').find('.is-invalid').removeClass('is-invalid');
			submitForm = settings.nette.el.closest('form');
		}

	},
	success: function (payload, status, xhr, settings) {
		// if there is redirect, we do nothing
		if (payload.redirect) {
			return true;
		}

		if (document.getElementById("palerma-overlay")) {
			document.getElementById("palerma-overlay").remove();
		} else {
			// if it's not netteAjax request, we do nothing
			if (!settings.nette) return true;

			if ($(settings.nette.el[0]).is(':visible')) {
				// we enable buttons
				settings.nette.el.find('.js-spinner').addClass('d-none');
				submitForm.find('button').prop('disabled', false);
			}

			// if it's a snippet redraw button with turn off validation, we do nothing
			if (settings.nette.el[0].hasAttribute("formnovalidate")) {
				return true;
			}

			// if there are errors in payload we will add them to appropriate inputs
			for (const elementId in payload.errors) {
				$('#' + elementId).addClass('is-invalid');
				for (const i in payload.errors[elementId]) {
					$('#' + elementId).after('<div class="invalid-feedback js-error">' + payload.errors[elementId][i] + '</div>');
				}
			}

			// if there are rendered errors we will scroll to first of them
			if (settings.nette.el.closest('form').find('.js-error').length > 0) {
				const $error = settings.nette.el.closest('form').find('.js-error:first');

				// we have to find first scrollable element (it can be document or modal for example)
				let scrollParent = Scrollparent($error[0]);
				if (scrollParent.tagName === 'BODY') {
					scrollParent = document.scrollingElement || document.documentElement;
				}

				$(scrollParent).animate({
					scrollTop: $error.offset().top - 100
				}, 500);
			}
		}
	},
	error:  function (xhr, status, error, settings) {
		if (document.getElementById("palerma-overlay")) {
			document.getElementById("palerma-overlay").remove();
		} else {
			if (!settings.nette) return true;

			if ($(settings.nette.el[0]).is(':visible')) {
				// we enable buttons
				settings.nette.el.find('.js-spinner').addClass('d-none');
				submitForm.find('button').prop('disabled', false);
			}
		}
	}
});